// eslint-disable arrow-body-style
import React from "react"

export const TranscriptIcon = ({ mode }: { mode: string }) => ( <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.94 39.94">
  <defs>
  {mode === 'light'  &&  <style>
        {`
    .b {
        stroke-width: 0px;
      }

      .c {
        fill: none;
      }

      .c, .d {
        stroke: #000;
      }

      .c, .d, .e {
        stroke-miterlimit: 10;
        stroke-width: 2px;
      }

      .d {
        fill: #fff;
        stroke: #000;
      }

      .e {
        fill: #0071bc;
        stroke: #0071bc;
      }
      `}
    </style> }
    {mode === 'dark' && <style>
        {`
    .b {
        stroke-width: 2px;
        stroke: #e8e8e8;
      }

      .c {
        fill: none;
        stroke-wdith: 2px;
      }

      .c, .d {
        stroke: #fff;
      }

      .c, .d, .e {
        stroke-miterlimit: 10;
        stroke-width: 2px;
      }

      .d {
        fill: #fff;
      }

      .e {
        fill: #0071bc;
        stroke: #0071bc;
      }
      `}
    </style> 
    }
  </defs>
  <path className="b" d="M22.55,6.72c4.31,0,7.81,3.51,7.81,7.81v22.19H10.37V6.72h12.19M22.55,4.72h-12.37c-1,0-1.81.81-1.81,1.81v30.37c0,1,.81,1.81,1.81,1.81h20.37c1,0,1.81-.81,1.81-1.81V14.53c0-5.42-4.39-9.81-9.81-9.81h0Z"/>
  <path className="d" d="M20.94,10.11c0,5.19-4.21,9.39-9.39,9.39S2.15,15.3,2.15,10.11,6.36.72,11.54.72s9.39,4.21,9.39,9.39"/>
  <rect className="e" x="9.98" y="3.85" width="3.13" height="7.83" rx="1.57" ry="1.57" transform="translate(23.09 15.53) rotate(180)"/>
  <path className="e" d="M15.46,9.83c0,2.16-1.75,3.91-3.91,3.91s-3.91-1.75-3.91-3.91"/>
  <line className="e" x1="13.55" y1="15.18" x2="9.54" y2="15.18"/>
  <line className="e" x1="11.54" y1="13.73" x2="11.54" y2="15.89"/>
  <line className="c" x1="13.98" y1="25.94" x2="27.24" y2="25.94"/>
  <line className="c" x1="13.98" y1="19.94" x2="27.24" y2="19.94"/>
  <line className="c" x1="13.98" y1="31.94" x2="27.24" y2="31.94"/>
</svg>
)

export const TranscriptNone = ({ mode }: { mode: string }) => ( <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
  
  <defs>
{
  mode ==='light' &&   <style>
  {`
  .x {
    stroke: red;
    stroke-width: 4px;
  }

  .x, .y {
    fill: none;
    stroke-miterlimit: 10;
  }

  .z {
    stroke-width: 0px;
  }

  .y {
    stroke: #000;
    stroke-width: 2px;
  }
  `}
</style> }
{mode === 'dark' &&  <style>
  {`
  .x {
    stroke: red;
    stroke-width: 4px;
  }

  .x, .y {
    fill: none;
    stroke-miterlimit: 10;
  }

  .z {
    stroke-width: 2px;
    fill: #fff;
    stroke: #fff;
  }

  .y {
    stroke: #fff;
    stroke-width: 2px;
  }
  `}
</style> }

  </defs>
  <line className="y" x1="15.8" y1="14.17" x2="29.06" y2="14.17"/>
  <path className="z" d="M24.23,6c4.31,0,7.81,3.51,7.81,7.81v22.19H12.04V6h12.19M24.23,4h-12.37c-1,0-1.81.81-1.81,1.81v30.37c0,1,.81,1.81,1.81,1.81h20.37c1,0,1.81-.81,1.81-1.81V13.82c0-5.42-4.39-9.81-9.81-9.81h0Z"/>
  <line className="y" x1="15.65" y1="25.23" x2="28.91" y2="25.23"/>
  <line className="y" x1="15.65" y1="19.23" x2="28.91" y2="19.23"/>
  <line className="y" x1="15.65" y1="31.23" x2="28.91" y2="31.23"/>
  <line className="x" x1="30.43" y1="14.51" x2="14.35" y2="30.13"/>
  <line className="x" x1="14.35" y1="14.51" x2="30.43" y2="30.13"/>
</svg>

)